import script from "./ReportManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportManagement.vue?vue&type=script&setup=true&lang=js"

import "./ReportManagement.vue?vue&type=style&index=0&id=567585b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567585b3"]])

export default __exports__